export default __webpack_public_path__ + "static/media/EMIIcon.df49c75a.svg";